import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const CircleCheckFilledIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M8.00008 0.832031C11.958 0.832207 15.1661 4.04304 15.1661 8.00098C15.1654 11.9583 11.9575 15.1668 8.00008 15.167C4.04266 15.1668 0.833796 11.9583 0.833092 8.00098C0.833092 4.04307 4.04223 0.83225 8.00008 0.832031Z"
      fill="currentColor"
    />
    <path
      d="M10.4425 6.22363C10.1985 5.97983 9.80173 5.97986 9.5577 6.22363L7.33309 8.44824L6.44247 7.55762C6.19845 7.31382 5.80173 7.31385 5.5577 7.55762C5.31439 7.80163 5.3142 8.19752 5.5577 8.44141L6.89169 9.77441C7.13567 10.0182 7.53143 10.0181 7.77548 9.77441L10.4425 7.1084C10.6862 6.86436 10.6863 6.46764 10.4425 6.22363Z"
      fill="white"
    />
  </svg>
);
